import { useEffect, useMemo, useState } from "react";
import Dialog from "src/SharedComponents/Dialog/Dialog";
import './AddDemoTrialLicense.css';
import Button from "src/SharedComponents/Button/Button";
import AssignDemoTrialLicense from "../AssignDemoTrialLicense/AssignDemoTrialLicense";
import { IPartnerClinicDetails } from "src/Utils/Hooks/GetPartnersInfo/GetPartnersClinics/useGetPartnersClinicsInfo";
import { useDistributorLicenseServiceWrapper } from "src/Utils/Hooks/LicenseService/useDistributorLicenseServiceWrapper";
import { AddLicenseType } from "src/Utils/Hooks/LicenseService/useDistributorLicenseService";
import Stepper from "src/SharedComponents/NumberStepper/NumberStepper";
import AssignDemoTrialLicenseToPartner from "../AssignDemoTrialLicense/AssingDemoTrialLicenseToPartner";
import { useSupportPermissions } from "src/Utils/Hooks/useGetAdminInfo/useSupportPermissions";

export interface IDemoTrialLicense {
    partnerClinics: IPartnerClinicDetails[];
    onCloseAddDialog: () => void;
    updateLicenses: () => void;
}

const AddDemoTrialLicense: React.FC<IDemoTrialLicense> = ({ partnerClinics, onCloseAddDialog, updateLicenses }) => {
    const [display, setDisplay] = useState('block');
    const [selectedOption, setSelectedOption] = useState<string>("Demo");
    const [showClinicAssignDialog, setShowClinicAssignDialog] = useState<boolean>(false);
    const [showPartnerAssignDialog, setShowPartnerAssignDialog] = useState<boolean>(false);
    const { reqestResponse, reqestError, assignTrailDemoLicenseToClinic, assignTrailDemoLicenseToPartner } = useDistributorLicenseServiceWrapper();
    const { isSupportAdmin } = useSupportPermissions();
    const [seatCount, setSeatCount] = useState<number>(10);
    const minSeatCount = 1;
    const maxSeatCount = 30;
    const addClinicLicenseBtn = () => {
        setShowClinicAssignDialog(true);
        setDisplay('none');
    };

    const addPartnerLicenseBtn = () => {
        setShowPartnerAssignDialog(true);
        setDisplay('none');
    };

    const handleRadioChange = (option: string) => {
        setSelectedOption(option);
    };


    useEffect(() => {
        if (reqestResponse) {
            setShowClinicAssignDialog(false);
            setShowPartnerAssignDialog(false);
            setDisplay('none');
            onCloseAddDialog();
            updateLicenses();
        }
    }, [reqestResponse, onCloseAddDialog, updateLicenses])

    useEffect(() => {
        if (reqestError) {
            setShowClinicAssignDialog(false);
            setShowPartnerAssignDialog(false);
            setDisplay('none');
            onCloseAddDialog();
        }
    }, [reqestError, onCloseAddDialog])

    const isSeatCountInValidRange = useMemo(() => {
        return seatCount >= minSeatCount && seatCount <= maxSeatCount;
    }, [seatCount])
    return (
        <>
            {
                showClinicAssignDialog && (
                    <AssignDemoTrialLicense
                        partnerClinics={partnerClinics}
                        licenseType={selectedOption}
                        onClose={() => { setShowClinicAssignDialog(false); setDisplay('none'); onCloseAddDialog(); }}
                        onSubmit={(clinicId: string, licenseType: string, clinicName: string) => {
                            assignTrailDemoLicenseToClinic(licenseType as AddLicenseType, clinicId, clinicName, seatCount);
                        }}
                    />
                )
            }
            {
                showPartnerAssignDialog && (
                    <AssignDemoTrialLicenseToPartner
                        licenseType={selectedOption}
                        onClose={() => { setShowClinicAssignDialog(false); setDisplay('none'); onCloseAddDialog(); }}
                        onSubmit={(clinicId: string, licenseType: string, clinicName: string) => {
                            assignTrailDemoLicenseToPartner(licenseType as AddLicenseType, clinicId, clinicName, seatCount);
                        }}
                    />
                )
            }
            <div style={{ display: display }}>
                <Dialog
                    title="Add Demo or Trial Licence"
                    headerAlign="left"
                    submitText="Enter"
                    contentWidth="30%"
                    onClose={() => { onCloseAddDialog(); setDisplay('none') }}
                    onSubmit={() => { }}
                    hideSubmit={true}
                >
                    <>
                        <div className="row">
                            <div className="radio-container">
                                <input
                                    type="radio"
                                    name="licenseType"
                                    value="Demo"
                                    checked={selectedOption === 'Demo'}
                                    onChange={() => handleRadioChange('Demo')}
                                    className="custom-radio"
                                />
                                <div className="radio-content">
                                    <span className={`radio-header ${selectedOption === 'Demo' ? 'bold' : ''}`}>
                                        Demo Licence
                                    </span>
                                    <p className={`radio-description ${selectedOption === 'Demo' ? 'bold' : ''}`}>
                                        Valid for 1 year,  250 GB Cloud storage
                                    </p>
                                </div>
                            </div>
                            <div className={`row ${selectedOption === 'Trial' ? 'disabled' : ''}`} style={{ marginLeft: '15px', marginTop: '25px', marginBottom: '25px' }}>
                                <span className="col-md-4 ds-text-primary">Floating Seats</span>
                                <div className="col-md-6">
                                    <Stepper
                                        value={seatCount}
                                        onChange={(val) => {
                                            setSeatCount(val);
                                        }
                                        }
                                        min={1} max={30} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="radio-container">
                                <input
                                    type="radio"
                                    name="licenseType"
                                    value="Trial"
                                    checked={selectedOption === 'Trial'}
                                    onChange={() => handleRadioChange('Trial')}
                                    className="custom-radio"
                                />
                                <div className="radio-content">
                                    <span className={`radio-header ${selectedOption === 'Trial' ? 'bold' : ''}`}>
                                        Trial Licence
                                    </span>
                                    <p className={`radio-description ${selectedOption === 'Trial' ? 'bold' : ''}`}>
                                        Valid for 30 days, 10 Floating seats, 250 GB Cloud storage
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-md-5">
                                <div className="button-container">
                                    <Button
                                        testId='ok'
                                        onClick={() => { addPartnerLicenseBtn() }}
                                        text="Assign to Partner"
                                        width="182px"
                                        disable={!isSeatCountInValidRange || !isSupportAdmin}
                                    />
                                </div>
                            </div>
                            <div className="col-md-5">
                                <div className="button-container">
                                    <Button
                                        testId='ok'
                                        onClick={() => { addClinicLicenseBtn() }}
                                        text="Assign to Clinic"
                                        width="182px"
                                        disable={!isSeatCountInValidRange || !isSupportAdmin}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                </Dialog>
            </div>
        </>
    );
};

export default AddDemoTrialLicense;